.text {
  font-size: 16px;
  font-weight: 300;
  color: #3b3b3b;
}
